<!--begin header -->
<header class="header">
    <app-header [addlClass]="'home-header'"></app-header>
</header>
<!--end header -->





<!--begin home section -->
<section class="home-section" id="home" aria-label="Overseas Education Payments - SingX">

    <!-- <div class="home-section-overlay"></div> -->

    <!--begin container -->
    <div class="container">

        <div class="row d-flex align-items-center mt-3">
            <div class="col-lg-6 col-md-12 mt-3">
                <h1 [attr.data-aos]="'fade-up'" data-aos-duration="500" class="text-white"
                    style="font-weight: 700; font-size: 38px;">Overseas
                    Education Payments - Save up
                    to 10%</h1>
                <p class="hero-text" [attr.data-aos]="'fade-up'" data-aos-delay="50" data-aos-duration="500">Pay directly into
                    your child's account for tuition fees and living expenses</p>
                <a (click)="redirectToRegistration()" class="btn getStarted"
                    [attr.style]="isMobile ? 'padding-left:20px;padding-right:20px;':'padding-left:48px;padding-right:48px;'">Get
                    Started</a>
                <!--<a rel="noreferrer" href="#" class="btn getStarted" style="margin-left: 20px;">Compare Rates</a>-->
            </div>
            <div class="col-lg-5 col-md-12 offset-lg-1">

                <div class="excalc-form-warpper" [attr.data-aos]="isMobile ? 'fade-up' : 'fade-left'"
                    data-aos-duration="1000">

                    <h3 class="mb-3 text-bold">Fair Exchange Calculator</h3>
                    <div>
                        <app-ex-calc></app-ex-calc>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <!--end container -->
</section>
<!--end home section -->

<!-- award section started-->
<section style="margin-top: -80px; margin-right: 0;z-index: 999;
position: relative;">
    <div class="row" style="margin-right: 0;">
        <div class="col-lg-5 col-md-12"></div>
        <div class="col-lg-6 col-md-12 offset-lg-1">
            <div class="row" style="align-items: baseline;">
                <!--
                <div class="col-md-4 cent" style="text-align: center;padding: 10px;margin-left: -40px;">
                    <div class="review-widget_net" data-uuid="9f54989e-efbc-4dc4-8c0b-f9cbee3f8a16" data-template="10"
                        data-filter="" data-lang="en" data-theme="light">
                        <a href="https://www.review-widget.net/" target="_blank" rel="noopener"><img
                                src="https://grwapi.net/assets/spinner/spin.svg" title="Google Review Widget"
                                alt="Review Widget"></a>
                    </div>
                </div>
            -->
                <div class="col-md-4" style="text-align: center;padding-top: 15px;"><a
                        href="https://search.google.com/local/reviews?placeid=ChIJRXlLlg0Z2jERdtIfqV-fVTs"
                        target="_blank"><img class="lazyload" data-src="./assets/images/google_review.webp"
                            alt="SingX Money Transfer Overseas - Google Review" style="width: 200px;"></a></div>
                <div class="col-md-3" style="text-align: center;padding: 10px;"><img class="lazyload"
                        data-src="./assets/images/MAS_Award_Icon.webp"
                        alt="SingX Transfer Money Overseas - MAS Global Fintech Award 2017"
                        [attr.style]="isMobile ? 'width: 120px;':'width: 150px;'"></div>
                <div class="col-md-3" style="text-align: center;padding-top: 15px;"><img class="lazyload"
                        data-src="./assets/images/SBR_Hottest_award.webp"
                        alt="SingX International Fund Transfer - Hottest Startup in 2018 Award" style="width: 150px;">
                </div>
            </div>
        </div>
    </div>
</section>
<!-- award section end-->



<section class="education info" id="education-savings" style="margin-top: 50px;">
    <div class="container" style="padding-top: 50px;">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="section-title mb-5 ng-tns-c74-0">Save On Your Money Transfer With SingX</h2>
                <p class="infoP">Studying overseas can be an expensive affair. We can help you <span
                        class="text-orange">save over SGD 1,500 in remittance fees</span> every year! </p>
                <p class="infoP">The average annual cost of studying in Australia can be broken down into:</p>
                <div class="row">
                    <div class="col-md-4 text-center"></div>
                    <div class="col-md-8 text-center">
                        <table class="calculation" style="text-align: left;">
                            <tr>
                                <td>
                                    <p class="infoP">Tuition fees:</p>
                                </td>
                                <td><span style="padding: 10px;"></span></td>
                                <td>
                                    <p class="infoP">AUD 55,000</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="infoP">Living expenses:</p>
                                </td>
                                <td></td>
                                <td>
                                    <p class="infoP">AUD 35,000</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="infoP">Misc (travel, insurance):</p>
                                </td>
                                <td></td>
                                <td>
                                    <p class="infoP">AUD 10,000</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="infoP text-bold">Total cost:</p>
                                </td>
                                <td></td>
                                <td>
                                    <p class="infoP text-bold">AUD 100,000</p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>



                <br>
                <p class="infoP">Plus the <b>cost of remitting this money to Australia is usually over SGD 1,800!</b>
                    That's right, banks claim to have low fees, but in reality there are a number of hidden charges
                    including:
                </p>

                <!--begin container-fluid-->
                <div class="container-fluid">
                    <!--begin row -->
                    <div class="row" style="padding: 10px 30px;">

                        <!--begin col-md-4 -->
                        <div class="col-md-12 ">
                            <div class="container-fluid col-md-12 bg-white rounded" data-aos="fade-up"
                                data-aos-duration="1000" style="padding-top: 20px;">
                                <div class="container-fluid col-md-4 " style="text-align: left;">
                                    <p>1. Margins built into the FX rates</p>
                                    <p>2. Receiver bank charges</p>
                                    <p>3. Cable and commission fees</p>
                                </div>
                            </div>
                        </div>
                        <!--end col-md-4 -->
                    </div>
                    <!--end row -->
                </div>
                <!--end container-fluid-->
                <br>
                <p class="infoP">At SingX, we offer live interbank exchange rates with no margins. We only charge a
                    small fee which is fully transparent and shown to you upfront. In the above example, <b>our cost is
                        only SGD 252</b>, so you end up saving approximately SGD 1,500 annually!
                </p>
            </div>
            <!-- <div class="bni-done" style="margin-top:40px;">
                <a ng-click="initBusinessCalculator();" style="cursor: pointer;" class="btn-main">Compare Rates Now</a>
            </div> -->
        </div>
        <div class="col-lg-12" style="padding: 20px;"></div>
    </div>
</section>

<app-why-singx [isMobile]="isMobile"></app-why-singx>

<app-how-it-works [isMobile]="isMobile"></app-how-it-works>

<app-country-coverage></app-country-coverage>

<!--begin testimonials section -->

<section id="testimonials" [attr.class]="isMobile ? 'section-bg-2 pt30-0 ' : 'section-bg-2'">

    <!--begin container -->
    <div class="container">

        <!--begin row -->
        <div class="row align-items-center">
            <div class="col-md-12">
                <h2 class="text-center mb-5 happycust">Happy Customers Say it Best!</h2>
                <!-- Demo header-->
                <div id="tcar" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#tcar" data-slide-to="0" class="active"></li>
                        <li data-target="#tcar" data-slide-to="1"></li>
                        <li data-target="#tcar" data-slide-to="2"></li>
                        <li data-target="#tcar" data-slide-to="3"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="carousel-item" style="min-height: 500px;margin:10px;"
                            *ngFor="let t of testimonialItems;let indexOfelement=index;"
                            [class.active]="indexOfelement == 0">
                            <div class="row">
                                <div class="col-md-5 col-sm-12" *ngIf="t.name_l">
                                    <div
                                        [attr.class]="isMobile ? 'card bg-white shadow rounded p-5 cardHWMob ' : 'card bg-white shadow rounded p-5 cardHWDesk'">
                                        <h6>{{t.name_l}}</h6>
                                        <p style="font-size: 17px;"> <i
                                                class="fa fa-quote-left mr-3 text-orange"></i>{{t.content_l}}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-1"></div>
                                <div class="col-md-5 col-sm-12" *ngIf="t.name_r">
                                    <div
                                        [attr.class]="isMobile ? 'card bg-white shadow rounded p-5 cardHWMob ' : 'card bg-white shadow rounded p-5 cardHWDesk'">
                                        <h6>{{t.name_r}}</h6>
                                        <p style="font-size: 17px;"> <i
                                                class="fa fa-quote-left mr-3 text-orange"></i>{{t.content_r}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-md-6-->
        </div>
        <!--end row -->
    </div>
    <!--end container -->
</section>
<!--end testimonials section -->



<div class="ltn__call-to-action-area call-to-action-6 pt30-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="call-to-action-inner">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 text-center">
                            <h4 class="center"
                                style="text-align: center;color: #071e55;font-weight: bold; font-size: 40px;">WELCOME
                                OFFER</h4>
                            <h4 class="center text-white text-bold">Enjoy your first 2 Transfers absolutely FREE!</h4>
                            <br>
                            <a (click)="redirectToRegistration()" class="btn btn-light bg-white"
                                style="padding: 1rem 3rem; border-radius: 10px;color: #ff6600!important;font-weight: bolder;">Sign
                                Up in 5 Mins!</a>
                        </div>

                    </div>
                </div>
                <div class="col-lg-12" style="padding: 20px;"></div>
            </div>
        </div>
    </div>
</div>





<app-footer></app-footer>